/**
 * URL query-string and hash-fragment parameter keys.
 * Compared values (e.g. braindump, signup) live in src/enums/.
 * Read params via getQueryParam() from utils/routes.util.ts.
 */

export const PLATFORM_INTEGRATION_QUERY_PARAM = {
  LOCATION: 'location',
  ACCOUNT_SERVER: 'accounts-server',
  CODE: 'code',
  IS_DEVELOPMENT: 'is_development'
} as const;

/** Hash-fragment keys (#token=...) — not the same as query-string ?token= */
export const URL_HASH_PARAM = {
  TOKEN: 'token'
} as const;

export const AUTH_QUERY_PARAM = {
  TOKEN: 'token',
  EMAIL: 'email',
  UI: 'ui',
  SIGN_INTO_DESKTOP: 'sign_into_desktop',
  PLATFORM: 'platform'
} as const;

export const TEAM_QUERY_PARAM = {
  TEAM_ID: 'team_id',
  JOIN_CODE: 'join_code'
} as const;

export const WEBVIEW_QUERY_PARAM = {
  DEVICE_ID: 'device_id',
  EDIT_SPECIFIC_ROUTINE: 'edit_specific_routine',
  OPEN: 'open'
} as const;

export const NAV_QUERY_PARAM = {
  TAB: 'tab',
  URL: 'url',
  LANGUAGE: 'lang'
} as const;

export const HABITS_QUERY_PARAM = {
  ADD_HABITS_MODE: 'add-habits-mode'
} as const;

export const SUBSCRIPTION_QUERY_PARAM = {
  LIFETIME_LICENSE_ENABLED: 'lifetime_license_enabled'
} as const;

export const COURSE_QUERY_PARAM = {
  COURSE_ID: 'course_id'
} as const;

export const PROJECT_QUERY_PARAM = {
  FOCUS: 'focus',
  NOTE_ID: 'note_id'
} as const;

/** Marketplace catalog filters: entity type (?filter=) and ownership (?owner=). */
export const MARKETPLACE_QUERY_PARAM = {
  FILTER: 'filter',
  OWNER: 'owner'
} as const;

/** Calendar events API query keys (`GET /calendar/:platform/events`). */
export const CALENDAR_EVENTS_QUERY_PARAM = {
  ACCOUNT: 'account',
  DAY: 'day',
  /** Range length in days (1–90). Do not send with `day`. */
  DAYS: 'days'
} as const;

/** AuDHD test results deep link (`/view-audhd-results?test-code=...`). */
export const AUDHD_QUERY_PARAM = {
  TEST_CODE: 'test-code'
} as const;

/** Flat map for existing call sites. Prefer domain exports for new code. */
export const PARAMS = {
  ...AUTH_QUERY_PARAM,
  ...TEAM_QUERY_PARAM,
  ...WEBVIEW_QUERY_PARAM,
  ...NAV_QUERY_PARAM,
  ...HABITS_QUERY_PARAM,
  ...SUBSCRIPTION_QUERY_PARAM,
  ...COURSE_QUERY_PARAM,
  ...PROJECT_QUERY_PARAM,
  ...CALENDAR_EVENTS_QUERY_PARAM,
  ...AUDHD_QUERY_PARAM,
  ...MARKETPLACE_QUERY_PARAM
} as const;
